export const GAME_RESULT_CODE_S_C = "S-C"
export const GAME_RESULT_CODE_S_S = "S-S"
export const GAME_RESULT_CODE_S_F = "S-F"
export const GAME_RESULT_CODE_S_IP = "S-IP"
export const GAME_RESULT_CODE_Ball = "Ball"
export const GAME_RESULT_CODE_Ill_Pi = "Ill-Pi"
export const GAME_RESULT_CODE_B_I = "B-I"
export const GAME_RESULT_CODE_IPs = "IPs"
export const GAME_RESULT_CODE_BF = "BF"
export const GAME_RESULT_CODE_PA = "PA"
export const GAME_RESULT_CODE_POS2 = "POS2"
export const GAME_RESULT_CODE_A = "A"
export const GAME_RESULT_CODE_PO = "PO"
export const GAME_RESULT_CODE_DP = "DP"
export const GAME_RESULT_CODE_TP = "TP"
export const GAME_RESULT_CODE_K = "K"
export const GAME_RESULT_CODE_G = "G"
export const GAME_RESULT_CODE_G_ = "G-"
export const GAME_RESULT_CODE_GT = "GT"
export const GAME_RESULT_CODE_F = "F"
export const GAME_RESULT_CODE_G_SH = "G-SH"
export const GAME_RESULT_CODE_F_SF = "F-SF"
export const GAME_RESULT_CODE_F_IF = "F-IF"
export const GAME_RESULT_CODE_LO = "LO"
export const GAME_RESULT_CODE_OT_PO = "OT-PO"
export const GAME_RESULT_CODE_BB = "BB"
export const GAME_RESULT_CODE_IBB = "IBB"
export const GAME_RESULT_CODE_HBP = "HBP"
export const GAME_RESULT_CODE_BB_I = "BB-I"
export const GAME_RESULT_CODE_BB_IL = "BB-IL"
export const GAME_RESULT_CODE_1B = "1B"
export const GAME_RESULT_CODE_2B = "2B"
export const GAME_RESULT_CODE_3B = "3B"
export const GAME_RESULT_CODE_HR = "HR"
export const GAME_RESULT_CODE_IHR = "IHR"
export const GAME_RESULT_CODE_FOT = "FOT"
export const GAME_RESULT_CODE_FC = "FC"
export const GAME_RESULT_CODE_OBC = "OBC"
export const GAME_RESULT_CODE_OBD = "OBD"
export const GAME_RESULT_CODE_UN_P = "UN-P"
export const GAME_RESULT_CODE_BK = "BK"
export const GAME_RESULT_CODE_SB = "SB"
export const GAME_RESULT_CODE_CS = "CS"
export const GAME_RESULT_CODE_PP1 = "PP1"
export const GAME_RESULT_CODE_POF1 = "POF1"
export const GAME_RESULT_CODE_PPO = "PPO"
export const GAME_RESULT_CODE_CPO = "CPO"
export const GAME_RESULT_CODE_INT = "INT"
export const GAME_RESULT_CODE_OTO_PB = "OTO-PB"
export const GAME_RESULT_CODE_OTO_PA = "OTO-PA"
export const GAME_RESULT_CODE_OT_RO = "OT-RO"
export const GAME_RESULT_CODE_UN_RO = "UN-RO"
export const GAME_RESULT_CODE_OTS_PB = "OTS-PB"
export const GAME_RESULT_CODE_OTS_PA = "OTS-PA"
export const GAME_RESULT_CODE_OT_RS = "OT-RS"
export const GAME_RESULT_CODE_UN_RS = "UN-RS"
export const GAME_RESULT_CODE_E_Foul = "E-Foul"
export const GAME_RESULT_CODE_E_OBPB = "E-OBPB"
export const GAME_RESULT_CODE_E_OBPA = "E-OBPA"
export const GAME_RESULT_CODE_E_OBRS = "E-OBRS"
export const GAME_RESULT_CODE_E_TPP = "E-TPP"
export const GAME_RESULT_CODE_E_CPP = "E-CPP"
export const GAME_RESULT_CODE_E_TOPB = "E-TOPB"
export const GAME_RESULT_CODE_E_TPA = "E-TPA"
export const GAME_RESULT_CODE_E_CPA = "E-CPA"
export const GAME_RESULT_CODE_E_TOPA = "E-TOPA"
export const GAME_RESULT_CODE_E_TRS = "E-TRS"
export const GAME_RESULT_CODE_E_CRS = "E-CRS"
export const GAME_RESULT_CODE_E_TORS = "E-TORS"
export const GAME_RESULT_CODE_E_TH = "E-TH"
export const GAME_RESULT_CODE_E_OBC = "E-OBC"
export const GAME_RESULT_CODE_E_OBD = "E-OBD"
export const GAME_RESULT_CODE_E_C = "E-C"
export const GAME_RESULT_CODE_E_T = "E-T"
export const GAME_RESULT_CODE_WP = "WP"
export const GAME_RESULT_CODE_PB = "PB"
export const GAME_RESULT_CODE_ABH = "ABH"
export const GAME_RESULT_CODE_RS01 = "RS01"
export const GAME_RESULT_CODE_LOB = "LOB"
export const GAME_RESULT_CODE_RISP = "RISP"
export const GAME_RESULT_CODE_RISPH = "RISPH"
export const GAME_RESULT_CODE_R = "R"
export const GAME_RESULT_CODE_RBI = "RBI"
export const GAME_RESULT_CODE_ER = "ER"
export const GAME_RESULT_CODE_W = "W"
export const GAME_RESULT_CODE_L = "L"
export const GAME_RESULT_CODE_SV = "SV"
export const GAME_RESULT_CODE_BS = "BS"
export const GAME_RESULT_CODE_Hold = "Hold"
export const GAME_RESULT_CODE_CG = "CG"
export const GAME_RESULT_CODE_SHO = "SHO"

export const GAME_RESULT_CODE_S_C_STRING = "沒揮好球(S-C)"
export const GAME_RESULT_CODE_S_S_STRING = "揮空好球(S-S)"
export const GAME_RESULT_CODE_S_F_STRING = "界外好球(S-F)"
export const GAME_RESULT_CODE_S_IP_STRING = "擊出好球(S-IP)"
export const GAME_RESULT_CODE_Ball_STRING = "壞球(Ball)"
export const GAME_RESULT_CODE_Ill_Pi_STRING = "違規壞球(Ill-Pi)"
export const GAME_RESULT_CODE_B_I_STRING = "故意壞球(B-I)"
export const GAME_RESULT_CODE_IPs_STRING = "出局數(IPs)"
export const GAME_RESULT_CODE_BF_STRING = "面對打者數(BF)"
export const GAME_RESULT_CODE_PA_STRING = "打席數(PA)"
export const GAME_RESULT_CODE_POS2_STRING = "守備位置捕手(POS2)"
export const GAME_RESULT_CODE_A_STRING = "助殺(A)"
export const GAME_RESULT_CODE_PO_STRING = "刺殺(PO)"
export const GAME_RESULT_CODE_DP_STRING = "雙殺(DP)"
export const GAME_RESULT_CODE_TP_STRING = "三殺(TP)"
export const GAME_RESULT_CODE_K_STRING = "三振(K)"
export const GAME_RESULT_CODE_G_STRING = "滾地球(G)"
export const GAME_RESULT_CODE_G__STRING = "自踩壘包(G-)"
export const GAME_RESULT_CODE_GT_STRING = "滾地球觸殺(GT)"
export const GAME_RESULT_CODE_F_STRING = "飛球出局(F)"
export const GAME_RESULT_CODE_G_SH_STRING = "滾地球-犧牲觸擊(G-SH)"
export const GAME_RESULT_CODE_F_SF_STRING = "飛球-犧牲飛球(F-SF)"
export const GAME_RESULT_CODE_F_IF_STRING = "飛球-內野飛球(F-IF)"
export const GAME_RESULT_CODE_LO_STRING = "跑離三呎線(LO)"
export const GAME_RESULT_CODE_OT_PO_STRING = "出局-其他(OT-PO)"
export const GAME_RESULT_CODE_BB_STRING = "保送(BB)"
export const GAME_RESULT_CODE_IBB_STRING = "敬遠保送(IBB)"
export const GAME_RESULT_CODE_HBP_STRING = "觸身球(HBP)"
export const GAME_RESULT_CODE_BB_I_STRING = "故意壞球保送(BB-I)"
export const GAME_RESULT_CODE_BB_IL_STRING = "違規投球保送(BB-IL)"
export const GAME_RESULT_CODE_1B_STRING = "一壘安打(1B)"
export const GAME_RESULT_CODE_2B_STRING = "二壘安打(2B)"
export const GAME_RESULT_CODE_3B_STRING = "三壘安打(3B)"
export const GAME_RESULT_CODE_HR_STRING = "全壘打(HR)"
export const GAME_RESULT_CODE_IHR_STRING = "場內全壘打(IHR)"
export const GAME_RESULT_CODE_FOT_STRING = "趁傳上壘(FOT)"
export const GAME_RESULT_CODE_FC_STRING = "野手選擇(FC)"
export const GAME_RESULT_CODE_OBC_STRING = "妨礙打擊(OBC)"
export const GAME_RESULT_CODE_OBD_STRING = "妨礙跑壘(OBD)"
export const GAME_RESULT_CODE_UN_P_STRING = "投球-不明(UN-P)"
export const GAME_RESULT_CODE_BK_STRING = "投手犯規(BK)"
export const GAME_RESULT_CODE_SB_STRING = "盜壘(SB)"
export const GAME_RESULT_CODE_CS_STRING = "盜壘失敗(CS)"
export const GAME_RESULT_CODE_PP1_STRING = "牽制一壘(PP1)"
export const GAME_RESULT_CODE_POF1_STRING = "牽制一壘出局(POF1)"
export const GAME_RESULT_CODE_PPO_STRING = "遭到牽制出局(PPO)"
export const GAME_RESULT_CODE_CPO_STRING = "捕手牽制出局(CPO)"
export const GAME_RESULT_CODE_INT_STRING = "妨礙守備(INT)"
export const GAME_RESULT_CODE_OTO_PB_STRING = "出局-其他-投球前(OTO-PB)"
export const GAME_RESULT_CODE_OTO_PA_STRING = "出局-其他-投球後(OTO-PA)"
export const GAME_RESULT_CODE_OT_RO_STRING = "特殊出局-其他(OT-RO)"
export const GAME_RESULT_CODE_UN_RO_STRING = "出局-不明(UN-RO)"
export const GAME_RESULT_CODE_OTS_PB_STRING = "進壘-其他-投球前(OTS-PB)"
export const GAME_RESULT_CODE_OTS_PA_STRING = "進壘-其他-投球後(OTS-PA)"
export const GAME_RESULT_CODE_OT_RS_STRING = "特殊進壘-其他(OT-RS)"
export const GAME_RESULT_CODE_UN_RS_STRING = "進壘-不明(UN-RS)"
export const GAME_RESULT_CODE_E_Foul_STRING = "失誤-界外(E-Foul)"
export const GAME_RESULT_CODE_E_OBPB_STRING = "失誤-妨礙跑壘-投球前(E-OBPB)"
export const GAME_RESULT_CODE_E_OBPA_STRING = "失誤-妨礙跑壘-投球後(E-OBPA)"
export const GAME_RESULT_CODE_E_OBRS_STRING = "失誤-妨礙跑壘-跑壘狀況(E-OBRS)"
export const GAME_RESULT_CODE_E_TPP_STRING = "失誤-牽制傳球-投球前(E-TPP)"
export const GAME_RESULT_CODE_E_CPP_STRING = "失誤-牽制接球-投球前(E-CPP)"
export const GAME_RESULT_CODE_E_TOPB_STRING = "失誤-球傳出界-投球前(E-TOPB)"
export const GAME_RESULT_CODE_E_TPA_STRING = "失誤-傳球-投球後(E-TPA)"
export const GAME_RESULT_CODE_E_CPA_STRING = "失誤-接球-投球後(E-CPA)"
export const GAME_RESULT_CODE_E_TOPA_STRING = "失誤-球傳出界-投球後(E-TOPA)"
export const GAME_RESULT_CODE_E_TRS_STRING = "失誤-傳球-跑壘狀況(E-TRS)"
export const GAME_RESULT_CODE_E_CRS_STRING = "失誤-接球-跑壘狀況(E-CRS)"
export const GAME_RESULT_CODE_E_TORS_STRING = "失誤-球傳出界-跑壘狀況(E-TORS)"
export const GAME_RESULT_CODE_E_TH_STRING = "失誤-被球打到(E-TH)"
export const GAME_RESULT_CODE_E_OBC_STRING = "失誤-妨礙打擊(E-OBC)"
export const GAME_RESULT_CODE_E_OBD_STRING = "失誤-妨礙跑壘(E-OBD)"
export const GAME_RESULT_CODE_E_C_STRING = "失誤-接球-擊出(E-C)"
export const GAME_RESULT_CODE_E_T_STRING = "失誤-傳球-擊出(E-T)"
export const GAME_RESULT_CODE_WP_STRING = "暴投(WP)"
export const GAME_RESULT_CODE_PB_STRING = "捕逸(PB)"
export const GAME_RESULT_CODE_ABH_STRING = "打者推進(ABH)"
export const GAME_RESULT_CODE_RS01_STRING = "跑者趁傳(RS01)"
export const GAME_RESULT_CODE_LOB_STRING = "殘壘(LOB)"
export const GAME_RESULT_CODE_RISP_STRING = "得點圈無安(RISP)"
export const GAME_RESULT_CODE_RISPH_STRING = "得點圈安打(RISPH)"
export const GAME_RESULT_CODE_R_STRING = "得分(R)"
export const GAME_RESULT_CODE_RBI_STRING = "打點(RBI)"
export const GAME_RESULT_CODE_ER_STRING = "責失分(ER)"
export const GAME_RESULT_CODE_W_STRING = "勝投(W)"
export const GAME_RESULT_CODE_L_STRING = "敗投(L)"
export const GAME_RESULT_CODE_SV_STRING = "救援成功(SV)"
export const GAME_RESULT_CODE_BS_STRING = "救援失敗(BS)"
export const GAME_RESULT_CODE_Hold_STRING = "中繼點(Hold)"
export const GAME_RESULT_CODE_CG_STRING = "完投(CG)"
export const GAME_RESULT_CODE_SHO_STRING = "完封(SHO)"

export const result_code_arr = [
    { val: GAME_RESULT_CODE_S_C, name: GAME_RESULT_CODE_S_C_STRING },
    { val: GAME_RESULT_CODE_S_S, name: GAME_RESULT_CODE_S_S_STRING },
    { val: GAME_RESULT_CODE_S_F, name: GAME_RESULT_CODE_S_F_STRING },
    { val: GAME_RESULT_CODE_S_IP, name: GAME_RESULT_CODE_S_IP_STRING },
    { val: GAME_RESULT_CODE_Ball, name: GAME_RESULT_CODE_Ball_STRING },
    { val: GAME_RESULT_CODE_Ill_Pi, name: GAME_RESULT_CODE_Ill_Pi_STRING },
    { val: GAME_RESULT_CODE_B_I, name: GAME_RESULT_CODE_B_I_STRING },
    { val: GAME_RESULT_CODE_IPs, name: GAME_RESULT_CODE_IPs_STRING },
    { val: GAME_RESULT_CODE_BF, name: GAME_RESULT_CODE_BF_STRING },
    { val: GAME_RESULT_CODE_PA, name: GAME_RESULT_CODE_PA_STRING },
    { val: GAME_RESULT_CODE_POS2, name: GAME_RESULT_CODE_POS2_STRING },
    { val: GAME_RESULT_CODE_A, name: GAME_RESULT_CODE_A_STRING },
    { val: GAME_RESULT_CODE_PO, name: GAME_RESULT_CODE_PO_STRING },
    { val: GAME_RESULT_CODE_DP, name: GAME_RESULT_CODE_DP_STRING },
    { val: GAME_RESULT_CODE_TP, name: GAME_RESULT_CODE_TP_STRING },
    { val: GAME_RESULT_CODE_K, name: GAME_RESULT_CODE_K_STRING },
    { val: GAME_RESULT_CODE_G, name: GAME_RESULT_CODE_G_STRING },
    { val: GAME_RESULT_CODE_G_, name: GAME_RESULT_CODE_G__STRING },
    { val: GAME_RESULT_CODE_GT, name: GAME_RESULT_CODE_GT_STRING },
    { val: GAME_RESULT_CODE_F, name: GAME_RESULT_CODE_F_STRING },
    { val: GAME_RESULT_CODE_G_SH, name: GAME_RESULT_CODE_G_SH_STRING },
    { val: GAME_RESULT_CODE_F_SF, name: GAME_RESULT_CODE_F_SF_STRING },
    { val: GAME_RESULT_CODE_F_IF, name: GAME_RESULT_CODE_F_IF_STRING },
    { val: GAME_RESULT_CODE_LO, name: GAME_RESULT_CODE_LO_STRING },
    { val: GAME_RESULT_CODE_OT_PO, name: GAME_RESULT_CODE_OT_PO_STRING },
    { val: GAME_RESULT_CODE_BB, name: GAME_RESULT_CODE_BB_STRING },
    { val: GAME_RESULT_CODE_IBB, name: GAME_RESULT_CODE_IBB_STRING },
    { val: GAME_RESULT_CODE_HBP, name: GAME_RESULT_CODE_HBP_STRING },
    { val: GAME_RESULT_CODE_BB_I, name: GAME_RESULT_CODE_BB_I_STRING },
    { val: GAME_RESULT_CODE_BB_IL, name: GAME_RESULT_CODE_BB_IL_STRING },
    { val: GAME_RESULT_CODE_1B, name: GAME_RESULT_CODE_1B_STRING },
    { val: GAME_RESULT_CODE_2B, name: GAME_RESULT_CODE_2B_STRING },
    { val: GAME_RESULT_CODE_3B, name: GAME_RESULT_CODE_3B_STRING },
    { val: GAME_RESULT_CODE_HR, name: GAME_RESULT_CODE_HR_STRING },
    { val: GAME_RESULT_CODE_IHR, name: GAME_RESULT_CODE_IHR_STRING },
    { val: GAME_RESULT_CODE_FOT, name: GAME_RESULT_CODE_FOT_STRING },
    { val: GAME_RESULT_CODE_FC, name: GAME_RESULT_CODE_FC_STRING },
    { val: GAME_RESULT_CODE_OBC, name: GAME_RESULT_CODE_OBC_STRING },
    { val: GAME_RESULT_CODE_OBD, name: GAME_RESULT_CODE_OBD_STRING },
    { val: GAME_RESULT_CODE_UN_P, name: GAME_RESULT_CODE_UN_P_STRING },
    { val: GAME_RESULT_CODE_BK, name: GAME_RESULT_CODE_BK_STRING },
    { val: GAME_RESULT_CODE_SB, name: GAME_RESULT_CODE_SB_STRING },
    { val: GAME_RESULT_CODE_CS, name: GAME_RESULT_CODE_CS_STRING },
    { val: GAME_RESULT_CODE_PP1, name: GAME_RESULT_CODE_PP1_STRING },
    { val: GAME_RESULT_CODE_POF1, name: GAME_RESULT_CODE_POF1_STRING },
    { val: GAME_RESULT_CODE_PPO, name: GAME_RESULT_CODE_PPO_STRING },
    { val: GAME_RESULT_CODE_CPO, name: GAME_RESULT_CODE_CPO_STRING },
    { val: GAME_RESULT_CODE_INT, name: GAME_RESULT_CODE_INT_STRING },
    { val: GAME_RESULT_CODE_OTO_PB, name: GAME_RESULT_CODE_OTO_PB_STRING },
    { val: GAME_RESULT_CODE_OTO_PA, name: GAME_RESULT_CODE_OTO_PA_STRING },
    { val: GAME_RESULT_CODE_OT_RO, name: GAME_RESULT_CODE_OT_RO_STRING },
    { val: GAME_RESULT_CODE_UN_RO, name: GAME_RESULT_CODE_UN_RO_STRING },
    { val: GAME_RESULT_CODE_OTS_PB, name: GAME_RESULT_CODE_OTS_PB_STRING },
    { val: GAME_RESULT_CODE_OTS_PA, name: GAME_RESULT_CODE_OTS_PA_STRING },
    { val: GAME_RESULT_CODE_OT_RS, name: GAME_RESULT_CODE_OT_RS_STRING },
    { val: GAME_RESULT_CODE_UN_RS, name: GAME_RESULT_CODE_UN_RS_STRING },
    { val: GAME_RESULT_CODE_E_Foul, name: GAME_RESULT_CODE_E_Foul_STRING },
    { val: GAME_RESULT_CODE_E_OBPB, name: GAME_RESULT_CODE_E_OBPB_STRING },
    { val: GAME_RESULT_CODE_E_OBPA, name: GAME_RESULT_CODE_E_OBPA_STRING },
    { val: GAME_RESULT_CODE_E_OBRS, name: GAME_RESULT_CODE_E_OBRS_STRING },
    { val: GAME_RESULT_CODE_E_TPP, name: GAME_RESULT_CODE_E_TPP_STRING },
    { val: GAME_RESULT_CODE_E_CPP, name: GAME_RESULT_CODE_E_CPP_STRING },
    { val: GAME_RESULT_CODE_E_TOPB, name: GAME_RESULT_CODE_E_TOPB_STRING },
    { val: GAME_RESULT_CODE_E_TPA, name: GAME_RESULT_CODE_E_TPA_STRING },
    { val: GAME_RESULT_CODE_E_CPA, name: GAME_RESULT_CODE_E_CPA_STRING },
    { val: GAME_RESULT_CODE_E_TOPA, name: GAME_RESULT_CODE_E_TOPA_STRING },
    { val: GAME_RESULT_CODE_E_TRS, name: GAME_RESULT_CODE_E_TRS_STRING },
    { val: GAME_RESULT_CODE_E_CRS, name: GAME_RESULT_CODE_E_CRS_STRING },
    { val: GAME_RESULT_CODE_E_TORS, name: GAME_RESULT_CODE_E_TORS_STRING },
    { val: GAME_RESULT_CODE_E_TH, name: GAME_RESULT_CODE_E_TH_STRING },
    { val: GAME_RESULT_CODE_E_OBC, name: GAME_RESULT_CODE_E_OBC_STRING },
    { val: GAME_RESULT_CODE_E_OBD, name: GAME_RESULT_CODE_E_OBD_STRING },
    { val: GAME_RESULT_CODE_E_C, name: GAME_RESULT_CODE_E_C_STRING },
    { val: GAME_RESULT_CODE_E_T, name: GAME_RESULT_CODE_E_T_STRING },
    { val: GAME_RESULT_CODE_WP, name: GAME_RESULT_CODE_WP_STRING },
    { val: GAME_RESULT_CODE_PB, name: GAME_RESULT_CODE_PB_STRING },
    { val: GAME_RESULT_CODE_ABH, name: GAME_RESULT_CODE_ABH_STRING },
    { val: GAME_RESULT_CODE_RS01, name: GAME_RESULT_CODE_RS01_STRING },
    { val: GAME_RESULT_CODE_LOB, name: GAME_RESULT_CODE_LOB_STRING },
    { val: GAME_RESULT_CODE_RISP, name: GAME_RESULT_CODE_RISP_STRING },
    { val: GAME_RESULT_CODE_RISPH, name: GAME_RESULT_CODE_RISPH_STRING },
    { val: GAME_RESULT_CODE_R, name: GAME_RESULT_CODE_R_STRING },
    { val: GAME_RESULT_CODE_RBI, name: GAME_RESULT_CODE_RBI_STRING },
    { val: GAME_RESULT_CODE_ER, name: GAME_RESULT_CODE_ER_STRING },
    { val: GAME_RESULT_CODE_W, name: GAME_RESULT_CODE_W_STRING },
    { val: GAME_RESULT_CODE_L, name: GAME_RESULT_CODE_L_STRING },
    { val: GAME_RESULT_CODE_SV, name: GAME_RESULT_CODE_SV_STRING },
    { val: GAME_RESULT_CODE_BS, name: GAME_RESULT_CODE_BS_STRING },
    { val: GAME_RESULT_CODE_Hold, name: GAME_RESULT_CODE_Hold_STRING },
    { val: GAME_RESULT_CODE_CG, name: GAME_RESULT_CODE_CG_STRING },
    { val: GAME_RESULT_CODE_SHO, name: GAME_RESULT_CODE_SHO_STRING },
]

